/** `/socialStats/summary` の dayRate / weekRate は既にパーセント値（例: 4 = 4%、0.1 = 0.1%） */
export const normalizeSocialRatePercent = (value: unknown): number | null => {
  if (value == null || value === '') return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return n;
};

export const formatSocialRate = (value: unknown): string => {
  const n = normalizeSocialRatePercent(value);
  if (n == null) return '—';
  return `${n > 0 ? '+' : ''}${n.toFixed(1)}%`;
};

/** 表示パーセントとバー幅を 1:1（最大 100%） */
export const socialRateBarWidth = (value: unknown): number => {
  const n = normalizeSocialRatePercent(value);
  if (n == null) return 0;
  return Math.min(Math.abs(n), 100);
};

/**
 * 投稿密集度（日次） densityIndex（0~100 の規整値）を表示用にフォーマットする。
 * null / 空文字 / NaN → 「—」、それ以外は [0,100] にクランプして小数 1 桁。
 * 既存の formatSocialRate は youtube.vue / ins.vue でも使われるため改変せず、本関数を新規追加する。
 */
export const formatDensityIndex = (value: unknown): string => {
  // normalizeSocialRatePercent を再利用して数値化（null/空/NaN → null）
  const n = normalizeSocialRatePercent(value);
  if (n == null) return '—';
  // 0~100 にクランプしてから小数 1 桁で表示（例: 88.8）
  const clamped = Math.min(Math.max(n, 0), 100);
  return clamped.toFixed(1);
};

/**
 * densityIndex（0~100）を進捗バーの幅（%）に変換する。
 * null → 0（バー非表示）、それ以外は [0,100] にクランプ。
 */
export const densityIndexBarWidth = (value: unknown): number => {
  const n = normalizeSocialRatePercent(value);
  if (n == null) return 0;
  return Math.min(Math.max(n, 0), 100);
};
